export default __webpack_public_path__ + "media/images/portfolio/width-600/portfolio-16-976db29e1471722136281e0286864f16.jpg";